window.bssB2BHooks = window.bssB2BHooks || {
    actions: {},
    filters: {},
};

window.BSS_B2B = window.BSS_B2B || {};

window.BSS_B2B.addAction = (tag, priority = 5, callback) => {
    window.bssB2BHooks.actions[tag] = window.bssB2BHooks.actions[tag] || [];
    window.bssB2BHooks.actions[tag][priority] = window.bssB2BHooks.actions[tag][priority] || [];
    window.bssB2BHooks.actions[tag][priority].push(callback);
}
window.BSS_B2B.addFilter = (tag, priority = 5, value) => {
    window.bssB2BHooks.filters[tag] = window.bssB2BHooks.filters[tag] || [];
    window.bssB2BHooks.filters[tag][priority] = window.bssB2BHooks.filters[tag][priority] || [];
    window.bssB2BHooks.filters[tag][priority].push(value);
}
const changeProductPriceOnSearchBar = function (shopData, isCPApplied) {
    if (isCPApplied) {
        const searchProduct = document.querySelectorAll('.modal__inner .modal__centered .modal__centered-content');
        searchProduct.forEach((e) => {
            if (e) {
                const handleSearch = mutations => {
                    for (let mutation of mutations) {
                        if (mutation.type === "childList") {
                            window.BSS_B2B.cp.changeProductPrice(shopData, null, false);
                        }
                    }
                };
                const observer = new MutationObserver(handleSearch);
                observer.observe(e, {
                    childList: true,
                    subtree: true
                });
            }
        })
        setTimeout(() => {
            const priceCP = document.querySelector('.product-single__meta .product__price span>span>span');
            if (priceCP) {
                const priceBundle = document.querySelector('#bundle-sticky_add_to_cart .bundle-sticky_money');
                priceBundle.innerText = priceCP.innerText
            }
        }, 3000)
    }
};

window.BSS_B2B.addAction(`price_search_bar`, 0, changeProductPriceOnSearchBar);
